import { MediaReportInputs } from './MediaReport';

export const mediaReportTransformer = (node: any): MediaReportInputs => {
    return {
        ctaLink: node.field_cta_link?.length > 0 && node.field_cta_link[0],
        fieldReportLink: node.field_report_link,
        learnMoreLink: node.field_learn_more_link,
        image: node.relationships?.field_callout_image,
        title: node.field_title ? node.field_title : node.field_component_title,
        textContent: node.field_text_content?.value,
    };
};
